export default "__VITE_ASSET__65020633__"